module.exports = "/images/NewZealand.png?5705524d9c38d0d482fa1e87c03fe7f2";